<template>
  <div class="search">
    <!-- Search filters form-->
    <div class="search-block row" v-click-outside="onClickOutside">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <b-form-input type="search"
               v-model="searchPhrase"
               v-on:click="showCustomFilters = !showCustomFilters;"
               v-on:keyup.enter="showCustomFilters = false"
               class="search-input"
               :placeholder="$t('search.searchForYour')" :aria-label="$t('search.searchForYour1')"
               :style="{ backgroundImage: 'url('+ getSrc('search.png')+')' }"/>
      </div>
      <div class="applied" v-if="userFilters && enabledCustomFilter">
        Applied: {{userFilters.filter(u=>u.id===enabledCustomFilter)[0].name}} filter
      </div>
      <div class="bottom-part" v-show="showCustomFilters">
        <b-button v-if="false" class="income-btn" @click="$emit('setSearch', searchPhrase); showCustomFilters = false">{{ $t('search.searchFor', { '1': searchPhrase }) }}</b-button>
        <div v-if="filterType !== 'strategy'">
          <h5>{{ $t('search.yourFavouriteFilters') }}</h5>
          <div class="custom-filters">
           <b-form-checkbox button class="filter-item b-form-tag" @input="setCustomFilter(customFilter)" name="check-button"
                             v-bind:class="enabledCustomFilter === customFilter.id ? 'active-filter' : 'not-active-filter'"
                             v-bind:ref="'user_filter_' + customFilter.id"
                             v-model="customFiltersStatuses[customFilter.id]"
                             v-on:change="showCustomFilters = false;"
                             switch
                             v-for="customFilter in this.customFilters.user_filters" v-bind:key="customFilter.id">
              {{ customFilter.name }}
              <b-button class="delete-filter" @click="deleteFilter(customFilter.id)">x</b-button>
            </b-form-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import filtersMixin from '../mixins/filters'
import imageMixin from '../mixins/image'

export default {
  name: 'Search',
  mixins: [filtersMixin, imageMixin],
  props: ['initialStrategyId', 'filterType'],
  data()
  {
    return {
      searchPhrase: '',
      showCustomFilters: false,
      userFilters: null,
      popularFilters: null
    }
  },
  created()
  {
    this.userFilters = this.$store.getters['filters/getListOfUserFilters']
    this.popularFilters = this.$store.getters['filters/getListOfPopularFilters']
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  computed: {},
  mounted()
  {
  },
  watch: {
    searchPhrase(phrase)
    {
        const userFilters = this.$store.getters['filters/getListOfUserFilters']
        const popularFilters = this.$store.getters['filters/getListOfPopularFilters']
        if (phrase)
        {
          this.customFilters.user_filters = userFilters.filter(c => c.name.toLowerCase().indexOf(phrase) !== -1)
          this.customFilters.popular_filters = popularFilters.filter(c => c.name.toLowerCase().indexOf(phrase) !== -1)
          this.showCustomFilters = true
        }
        else
        {
          this.customFilters.user_filters = userFilters
          this.customFilters.popular_filters = popularFilters
          this.$emit('setSearch')
          this.showCustomFilters = false
        }
    }
  },
  methods: {
    onClickOutside(event)
    {
      this.showCustomFilters = false
    }
  }
}
</script>
<style lang="scss">
.filter-item {
  label, .btn {
    background-color: transparent !important;
    color: var(--blue-income)  !important;
    border: 0 transparent !important;
    margin: 0;
    padding: 0;
    font-weight: normal;
    box-shadow: none !important;
  }
}
.active-filter {
  label, .btn {
    color: #FFFFFF !important;
    font-weight: normal;
    border: 0 transparent !important;
  }
}
</style>
<style lang="scss" scoped>
.custom-filters .filter-item .btn {
  background: rgba(120, 195, 205, 0.1);
  border-radius: 14px;
  border: 0;
  color: #30A7FE;
}

//.search-form, .search-form .form-inline, .search {
//  width: 95%;
//}
.applied{
  padding-left: 15px;
  font-weight: bold;
  margin-left: 5px;
  font-size: 13px;
  padding-top: 3px;
}

.search-block {
  min-width: 255px;
  border-radius: 4px;
  z-index: 2;
  margin-bottom: 10px;

  input {
    height: 40px;
    width: 100%;
  }

  .search-input {
    background-repeat: no-repeat;
    padding-left: 35px;
    background-position: 5px;
    background-color: white;
    font-size: 14px;
  }

  .bottom-part {
    min-width: 255px;
    margin: 45px 15px 15px 0;
    position: absolute;
    background: white;
    border: 1px solid #c3c3c3;
    border-radius: 2px;
    padding: 13px;
    display: table;
    z-index: 7;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  .filter-item {
    float: left;
    margin-right: 15px;
    background: rgba(120, 195, 205, 0.1);
    border-radius: 14px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #30A7FE;
    margin-bottom: 3px;

    label
    {
      color: red !important;
    }
  }

  h5 {
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 30px;
    font-feature-settings: 'liga' off;
    color: #000000;
    width: 100%;
    clear: both;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .custom-filters {
    margin-bottom: 5px;
    display: inline-block;
  }
}

.active-filter {
  background: #30A7FE !important;

  .btn-info {
    border-color: #30A7FE !important;
    background: #30A7FE !important;
  }
}

.delete-filter {
  margin-left: 10px;
  border-radius: 0 !important;
  margin-top: -14px;
}

@media (min-width: 576px) {
  .search .form-control {
    width: 100% !important;
  }
}

@media (min-width: 990px) {
  .search-form {
    margin-left: 5rem;
    margin-right: 5rem;
  }
}

</style>
